const appointmentCalendar = {
    appointment:'Appointment',
    appointmentCalendar:'Calendario de citas',
    newAppointment:'Nueva cita',
    fullCalendarView:'Vista completa del calendario',
    hideCalendarView:'Ocultar vista de calendario',

    addAppointment:{
      appointmentDetail:'Detalle de la cita',
      addAppointment:'añadir cita',
      patient:'Paciente',
      staff:'Personal',
      startDate:'Fecha de inicio',
      typeOfVisit:'Tipo de visita',
      note:'Nota',
     
  }
}


export default appointmentCalendar